// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.player-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.loader-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  z-index: 5;
}

.error-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  z-index: 5;
  text-align: center;
  padding: 20px;
}

.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.video-player-container {
  width: 100%;
  max-width: 100vw;
  background-color: #fff;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  height: 65vh;
  overflow: hidden;
}

@media (max-width: 768px) {
  .video-player-container {
    /* height: 92vh; */
    height: 35vh;
  }
}

.video-grid {
  display: grid;
  gap: 2px;
  width: 100%;
  flex-grow: 1; 
  flex-shrink: 1;
  overflow: visible; 
  min-height: 0; 
}

.video-grid.single {
  grid-template-columns: 1fr;
  aspect-ratio: 16 / 9;
}

.video-grid.even {
  grid-template-columns: 1fr; 
  grid-template-rows: repeat(2, minmax(0, 1fr)); 
  height: 100%; 
}

.video-grid.odd {
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: minmax(150px, auto);
}

.video-grid.odd > div:last-child {
  grid-column: span 2;
  aspect-ratio: 16 / 9;
}

.video-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: visible !important;
  aspect-ratio: 16 / 9; 
}

.no-video {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #000;
  color: #fff;
  font-size: 1rem;
}

.fullscreen-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  color: white;
  padding: 5px;
  cursor: pointer;
  z-index: 20;
}

.controls-container {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  background: #222;
  position: sticky;
  bottom: 0;
  z-index: 10;
  width: 100%;
  flex-shrink: 0; 
}

.control-button {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 1.5rem;
}

.volume-progress-bar {
  width: 100px;
  cursor: pointer;
}

.stepper-wrapper {
  display: none;
  padding: 5px;
  background: #222;
  position: sticky;
  bottom: 6px;
  z-index: 10;
  width: 100%;
  flex-shrink: 0;
  margin-top: 5px;
  border-radius: 3px;
}

.timeline-wrapper {
  width: 100%;
  margin-top: 6px;
  background: #fff;
  flex-shrink: 0; 
  min-height: 50px; 
  z-index: 5; 
}

@media (max-width: 768px) {
  .video-grid.even,
  .video-grid.odd {
    grid-template-columns: 1fr;
    grid-template-rows: minmax(0, 1fr); 
  }

  .video-grid.odd > div:last-child {
    grid-column: span 1; 
    aspect-ratio: 16 / 9;
  }

  .video-wrapper {
    aspect-ratio: 16 / 9;
  }

  .no-video {
    font-size: 0.8rem;
  }

  .controls-container {
    flex-direction: column;
    align-items: flex-start;
  }

  .volume-progress-bar {
    width: 100%;
  }

  .timeline-wrapper {
    min-height: 40px; 
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .video-grid.even {
    grid-template-columns: 1fr; 
    grid-template-rows: repeat(2, minmax(0, 1fr)); 
  }

  .video-grid.odd {
    grid-template-columns: repeat(2, 1fr);
    grid-auto-rows: minmax(120px, auto);
  }

  .video-grid.odd > div:last-child {
    grid-column: span 2;
    aspect-ratio: 16 / 9;
  }

  .video-wrapper {
    aspect-ratio: 16 / 9;
  }
}

@media (min-width: 1025px) and (max-width: 1440px) {
  .video-grid.even {
    grid-template-columns: 1fr; 
    grid-template-rows: repeat(2, minmax(0, 1fr)); 
  }

  .video-grid.odd {
    grid-template-columns: repeat(2, 1fr);
    grid-auto-rows: minmax(150px, auto);
  }

  .video-grid.odd > div:last-child {
    grid-column: span 2;
    aspect-ratio: 16 / 9;
  }
}

@media (min-width: 1441px) {
  .video-grid.even {
    grid-template-columns: 1fr; 
    grid-template-rows: repeat(2, minmax(0, 1fr)); 
  }

  .video-grid.odd {
    grid-template-columns: repeat(2, 1fr);
    grid-auto-rows: minmax(200px, auto);
  }

  .video-grid.odd > div:last-child {
    grid-column: span 2;
    aspect-ratio: 16 / 9;
  }
}

.custom-controls {
  position: absolute;
  bottom: 10px;
  left: 10px;
  display: flex;
  gap: 10px;
  background: rgba(0, 0, 0, 0.5);
  padding: 5px;
  border-radius: 5px;
}
.custom-controls button {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
}
.custom-controls input[type="range"] {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/video-controller/playback-video/cctvViewPlayer.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;IAClB,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,6CAA6C;EAC7C,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,WAAW;EACX,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE;;IAEE,0BAA0B;IAC1B,kCAAkC;EACpC;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,6CAA6C;EAC/C;;EAEA;IACE,qCAAqC;IACrC,mCAAmC;EACrC;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,6CAA6C;EAC/C;;EAEA;IACE,qCAAqC;IACrC,mCAAmC;EACrC;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,6CAA6C;EAC/C;;EAEA;IACE,qCAAqC;IACrC,mCAAmC;EACrC;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;AACA;EACE,eAAe;AACjB","sourcesContent":[".player-container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n.loader-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 5;\n}\n\n.error-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: rgba(0, 0, 0, 0.8);\n  color: white;\n  z-index: 5;\n  text-align: center;\n  padding: 20px;\n}\n\n.loader {\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #3498db;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.video-player-container {\n  width: 100%;\n  max-width: 100vw;\n  background-color: #fff;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  height: 65vh;\n  overflow: hidden;\n}\n\n@media (max-width: 768px) {\n  .video-player-container {\n    /* height: 92vh; */\n    height: 35vh;\n  }\n}\n\n.video-grid {\n  display: grid;\n  gap: 2px;\n  width: 100%;\n  flex-grow: 1; \n  flex-shrink: 1;\n  overflow: visible; \n  min-height: 0; \n}\n\n.video-grid.single {\n  grid-template-columns: 1fr;\n  aspect-ratio: 16 / 9;\n}\n\n.video-grid.even {\n  grid-template-columns: 1fr; \n  grid-template-rows: repeat(2, minmax(0, 1fr)); \n  height: 100%; \n}\n\n.video-grid.odd {\n  grid-template-columns: repeat(2, 1fr);\n  grid-auto-rows: minmax(150px, auto);\n}\n\n.video-grid.odd > div:last-child {\n  grid-column: span 2;\n  aspect-ratio: 16 / 9;\n}\n\n.video-wrapper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: visible !important;\n  aspect-ratio: 16 / 9; \n}\n\n.no-video {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #000;\n  color: #fff;\n  font-size: 1rem;\n}\n\n.fullscreen-button {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: rgba(0, 0, 0, 0.5);\n  border: none;\n  color: white;\n  padding: 5px;\n  cursor: pointer;\n  z-index: 20;\n}\n\n.controls-container {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px;\n  background: #222;\n  position: sticky;\n  bottom: 0;\n  z-index: 10;\n  width: 100%;\n  flex-shrink: 0; \n}\n\n.control-button {\n  background: none;\n  border: none;\n  color: white;\n  cursor: pointer;\n  font-size: 1.5rem;\n}\n\n.volume-progress-bar {\n  width: 100px;\n  cursor: pointer;\n}\n\n.stepper-wrapper {\n  display: none;\n  padding: 5px;\n  background: #222;\n  position: sticky;\n  bottom: 6px;\n  z-index: 10;\n  width: 100%;\n  flex-shrink: 0;\n  margin-top: 5px;\n  border-radius: 3px;\n}\n\n.timeline-wrapper {\n  width: 100%;\n  margin-top: 6px;\n  background: #fff;\n  flex-shrink: 0; \n  min-height: 50px; \n  z-index: 5; \n}\n\n@media (max-width: 768px) {\n  .video-grid.even,\n  .video-grid.odd {\n    grid-template-columns: 1fr;\n    grid-template-rows: minmax(0, 1fr); \n  }\n\n  .video-grid.odd > div:last-child {\n    grid-column: span 1; \n    aspect-ratio: 16 / 9;\n  }\n\n  .video-wrapper {\n    aspect-ratio: 16 / 9;\n  }\n\n  .no-video {\n    font-size: 0.8rem;\n  }\n\n  .controls-container {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .volume-progress-bar {\n    width: 100%;\n  }\n\n  .timeline-wrapper {\n    min-height: 40px; \n  }\n}\n\n@media (min-width: 769px) and (max-width: 1024px) {\n  .video-grid.even {\n    grid-template-columns: 1fr; \n    grid-template-rows: repeat(2, minmax(0, 1fr)); \n  }\n\n  .video-grid.odd {\n    grid-template-columns: repeat(2, 1fr);\n    grid-auto-rows: minmax(120px, auto);\n  }\n\n  .video-grid.odd > div:last-child {\n    grid-column: span 2;\n    aspect-ratio: 16 / 9;\n  }\n\n  .video-wrapper {\n    aspect-ratio: 16 / 9;\n  }\n}\n\n@media (min-width: 1025px) and (max-width: 1440px) {\n  .video-grid.even {\n    grid-template-columns: 1fr; \n    grid-template-rows: repeat(2, minmax(0, 1fr)); \n  }\n\n  .video-grid.odd {\n    grid-template-columns: repeat(2, 1fr);\n    grid-auto-rows: minmax(150px, auto);\n  }\n\n  .video-grid.odd > div:last-child {\n    grid-column: span 2;\n    aspect-ratio: 16 / 9;\n  }\n}\n\n@media (min-width: 1441px) {\n  .video-grid.even {\n    grid-template-columns: 1fr; \n    grid-template-rows: repeat(2, minmax(0, 1fr)); \n  }\n\n  .video-grid.odd {\n    grid-template-columns: repeat(2, 1fr);\n    grid-auto-rows: minmax(200px, auto);\n  }\n\n  .video-grid.odd > div:last-child {\n    grid-column: span 2;\n    aspect-ratio: 16 / 9;\n  }\n}\n\n.custom-controls {\n  position: absolute;\n  bottom: 10px;\n  left: 10px;\n  display: flex;\n  gap: 10px;\n  background: rgba(0, 0, 0, 0.5);\n  padding: 5px;\n  border-radius: 5px;\n}\n.custom-controls button {\n  background: none;\n  border: none;\n  color: white;\n  cursor: pointer;\n}\n.custom-controls input[type=\"range\"] {\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
